import React, { useCallback, useContext, useState } from "react";
import { FC } from "react";
import { NavBar } from "antd-mobile";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.less";
import { IconFont } from "../IconFont";
import { NavList } from "@/routes/User";
import classNames from "classnames";
import { message, Modal } from "antd";
import axios from "axios";
import { useNavigate } from "react-router";
import { LeftOutlined } from "@ant-design/icons";
import { MobileTopDownMenu, MobileTopDownMenuItem } from "../MobileTopDownMenu";
import { LANG_MAP, changeLang } from "@/locales";

const LANG_TOGGLE_MENUS: MobileTopDownMenuItem[] = LANG_MAP.map((item) => ({
  key: item.value,
  label: item.label,
  onClick: () => {
    changeLang(item.value);
  },
}));

export interface MobileLaunchpadLayoutProps {
  isFirstPage: boolean;
  pageTitle: string;
  navToFirstPage: () => void;
  showLangToggle?: boolean;
}

export const MobileLaunchpadLayout: FC<MobileLaunchpadLayoutProps> = ({
  children,
  pageTitle,
  isFirstPage,
  navToFirstPage,
  showLangToggle,
}) => {
  const avatarUrl = window.__config__?.userpoolLogo;

  const { t } = useTranslation();

  const [showMenu, setShowMenu] = useState(false);

  const [langMenuVisible, setLangMenuVisible] = useState(false);

  const navlist = useContext(NavList);

  const nav = useNavigate();

  const onLogout = useCallback(async () => {
    await axios.post("/logout");
    if (await window.__authing__.getCurrentUser()) {
      await window.__authing__.logout();
    }
    message.success(t("common.logoutSuccess"));
    setTimeout(() => {
      let redirect = "/login";
      if (window.__config__.logoutRedirectUris?.length) {
        redirect = window.__config__.logoutRedirectUris[0];
      }
      window.location.href = redirect;
    }, 500);
  }, [t]);

  const showLogout = useCallback(() => {
    Modal.warning({
      title: t("common.confirmLogout"),
      okCancel: true,
      onOk: onLogout,
    });
  }, [onLogout, t]);

  const actionList = [
    {
      key: "console",
      onClick: () => {
        window.location.href = "/console";
      },
      label: (
        <>
          <IconFont
            type="authing-server-line"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.dashboard")}
        </>
      ),
      unShow: () => window.__userPoolId__ !== window.__config__.rootUserPoolId,
    },
    {
      key: "launchpad",
      onClick: () => {
        nav("/launchpad");
      },
      label: (
        <>
          <IconFont
            type="authing-aspect-ratio-line"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.appPanel")}
        </>
      ),
      unShow: () => window.location.pathname === "/launchpad",
    },
    {
      key: "userCenter",
      onClick: () => {
        nav("/u");
      },
      label: (
        <>
          <IconFont
            type="authing-user-line1"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.personalCenter")}
        </>
      ),
      unShow: () => window.location.pathname === "/u",
    },
    {
      key: "logout",
      onClick: showLogout,
      label: (
        <>
          <IconFont
            type="authing-logout-circle-r-line"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.logout")}
        </>
      ),
    },
  ];

  const rigtMenu = (
    <MobileTopDownMenu
      menusList={[
        navlist.map((item) => ({
          ...item,
          onClick: () => {
            item.onClick();
            setShowMenu(false);
          },
        })),
        actionList.filter((item) => !item.unShow?.()),
      ]}
      visible={showMenu}
      onClose={() => setShowMenu(false)}
    ></MobileTopDownMenu>
  );

  return (
    <div className={styles.mobileLayout}>
      <NavBar
        mode="light"
        onLeftClick={() => navToFirstPage()}
        className={classNames(styles.layoutNavBar)}
        leftContent={
          isFirstPage ? (
            <>
              <img
                src={avatarUrl}
                className={styles.userpoolLogo}
                alt="Userpool"
              />
              <span className={styles.title}>{pageTitle}</span>
            </>
          ) : (
            <LeftOutlined style={{ color: "#000" }} />
          )
        }
        rightContent={
          <>
            {showLangToggle && (
              <IconFont
                type="authing-language"
                style={{ fontSize: 24, color: "#293350", marginRight: 19 }}
                onClick={() => {
                  setLangMenuVisible((v) => !v);
                  setShowMenu(false);
                }}
              />
            )}
            <IconFont
              type="authing-menu-fill"
              style={{ fontSize: 24, color: "#293350" }}
              onClick={() => {
                setShowMenu(!showMenu);
                setLangMenuVisible(false);
              }}
            />
          </>
        }
      >
        {!isFirstPage && pageTitle}
      </NavBar>
      {rigtMenu}

      {showLangToggle && (
        <MobileTopDownMenu
          menusList={[LANG_TOGGLE_MENUS]}
          visible={langMenuVisible}
          onClose={() => setLangMenuVisible(false)}
        ></MobileTopDownMenu>
      )}

      <div className={styles.content}>{children}</div>
    </div>
  );
};
